import {
	type CardDeleteRequestAction,
	CARD_DELETE_REQUEST,
} from '../../../actions/cards/delete/index.tsx';
import {
	type CloseDetailViewAction,
	type OpenDetailViewAction,
	CLOSE_DETAIL_VIEW,
	OPEN_DETAIL_VIEW,
	UPDATE_DETAIL_VIEW,
	type UpdateDetailViewAction,
} from '../../../actions/detail-view/index.tsx';
import type { DetailViewState } from './types.tsx';

type Action =
	| OpenDetailViewAction
	| CloseDetailViewAction
	| CardDeleteRequestAction
	| UpdateDetailViewAction;

export const detailViewReducer = (
	state: DetailViewState = null,
	action: Action,
): DetailViewState => {
	switch (action.type) {
		case OPEN_DETAIL_VIEW:
			if (!state || action.payload.cardId !== state.cardId) {
				return {
					timestamp: state ? state.timestamp : Date.now(),
					cardId: action.payload.cardId,
					externalAction: action.payload.externalAction,
				};
			}
			return state;

		case UPDATE_DETAIL_VIEW:
			return state ? { cardId: state.cardId, timestamp: Date.now() } : null;
		case CLOSE_DETAIL_VIEW:
			return null;
		case CARD_DELETE_REQUEST:
			if (state && state.cardId === action.payload.cardId) {
				return null;
			}
			return state;
		default:
			return state;
	}
};
